import { DefaultFilter, DefaultEditor, ɵbo, Ng2SmartTableModule, LocalDataSource } from 'ng2-smart-table';
export { Cell, DefaultEditor, DefaultFilter, LocalDataSource, ServerDataSource } from 'ng2-smart-table';
import { ɵɵdefineInjectable, ɵɵgetInheritedFactory, ɵsetClassMetadata, Injectable, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵInheritDefinitionFeature, ɵɵNgOnChangesFeature, ɵɵelementStart, ɵɵelement, ɵɵelementEnd, ɵɵadvance, ɵɵproperty, Component, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵtemplate, ɵɵclassProp, Input, EventEmitter, ɵɵpureFunction1, Output, ɵɵsanitizeHtml, ɵɵreference, ɵɵprojectionDef, ɵɵprojection, InjectionToken, ɵɵtext, ɵɵtextInterpolate1, Inject, Injector, ɵɵtextInterpolate, ɵɵtextInterpolate2, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { FormControl, NumberValueAccessor, DefaultValueAccessor, NgControlStatus, FormControlDirective, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import * as moment_ from 'moment';
import { NbCalendarViewMode, NbCalendarRangeComponent, NbUserComponent, NbDatepickerDirective, NbDatepickerComponent, NbCardComponent, NbCardBodyComponent, NbCheckboxComponent, NbButtonComponent, NbSpinnerDirective, NbLayoutDirectionService, NbThemeModule, NbInputModule, NbCheckboxModule, NbDatepickerModule, NbCalendarRangeModule, NbSpinnerModule, NbUserModule, NbButtonModule, NbCardModule } from '@nebular/theme';
import { NgIf, NgStyle, NgForOf, CommonModule } from '@angular/common';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { moveItemInArray, CdkDropList, CdkDrag, CdkDragHandle, DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayRef, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ExportToCsv } from 'export-to-csv';
import { NbMomentDateModule } from '@nebular/moment';

class SmartTableBackendWrapperConfigServiceAbstract {
}
class SmartTableBackendWrapperConfigService extends SmartTableBackendWrapperConfigServiceAbstract {
    getCustomTranslates() {
        return {
            filtering: {
                date_range: {
                    placeholder: 'range',
                },
                number_range: {
                    placeholder: {
                        min: 'Min',
                        max: 'Max'
                    }
                }
            },
        };
    }
}
/** @nocollapse */ SmartTableBackendWrapperConfigService.ɵfac = function SmartTableBackendWrapperConfigService_Factory(t) { return ɵSmartTableBackendWrapperConfigService_BaseFactory(t || SmartTableBackendWrapperConfigService); };
/** @nocollapse */ SmartTableBackendWrapperConfigService.ɵprov = ɵɵdefineInjectable({ token: SmartTableBackendWrapperConfigService, factory: SmartTableBackendWrapperConfigService.ɵfac, providedIn: 'root' });
const ɵSmartTableBackendWrapperConfigService_BaseFactory = ɵɵgetInheritedFactory(SmartTableBackendWrapperConfigService);
/*@__PURE__*/ (function () { ɵsetClassMetadata(SmartTableBackendWrapperConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

class CustomGridNumberRangeFilterComponent extends DefaultFilter {
    constructor(smartTableConfig) {
        super();
        this.smartTableConfig = smartTableConfig;
        this.inputFrom = new FormControl();
        this.inputTo = new FormControl();
        this.subs = [];
    }
    ngOnInit() {
        const placeholderTranslates = this.smartTableConfig.getCustomTranslates().filtering.number_range.placeholder;
        this.fromFilterText = placeholderTranslates.min;
        this.toFilterText = placeholderTranslates.max;
        this.subs.push(this.inputFrom.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(this.delay))
            .subscribe((value) => {
            this.query = value !== null ? this.getInputValues(this.inputFrom.value, this.inputTo.value) : '';
            this.setFilter();
        }));
        this.subs.push(this.inputTo.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(this.delay))
            .subscribe((value) => {
            this.query = value !== null ? this.getInputValues(this.inputFrom.value, this.inputTo.value) : '';
            this.setFilter();
        }));
    }
    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }
    ngOnChanges(changes) {
        /* if (changes.query) {
           console.log(changes.query);
           this.query = changes.query.currentValue;
           this.inputFrom.setValue(this.query);
         }*/
    }
    getInputValues(rangeFrom, rangeTo) {
        return [rangeFrom, rangeTo].join('_');
    }
}
/** @nocollapse */ CustomGridNumberRangeFilterComponent.ɵfac = function CustomGridNumberRangeFilterComponent_Factory(t) { return new (t || CustomGridNumberRangeFilterComponent)(ɵɵdirectiveInject(SmartTableBackendWrapperConfigService)); };
/** @nocollapse */ CustomGridNumberRangeFilterComponent.ɵcmp = ɵɵdefineComponent({ type: CustomGridNumberRangeFilterComponent, selectors: [["ngx-custom-grid-number-range-filter"]], features: [ɵɵInheritDefinitionFeature, ɵɵNgOnChangesFeature], decls: 7, vars: 2, consts: [[1, "row", "no-gutters", "custom_grid_size"], [1, "col-6", "pr-1"], [1, "input-group"], ["type", "number", "id", "inputFromNumber", "min", "0", "autocomplete", "off", 1, "form-control", "pr-1", 3, "formControl"], [1, "col-6", "pl-1"], ["type", "number", "id", "inputTo", "min", "0", "autocomplete", "off", 1, "form-control", "pr-1", 3, "formControl"]], template: function CustomGridNumberRangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelement(3, "input", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 2);
        ɵɵelement(6, "input", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("formControl", ctx.inputFrom);
        ɵɵadvance(3);
        ɵɵproperty("formControl", ctx.inputTo);
    } }, directives: [NumberValueAccessor, DefaultValueAccessor, NgControlStatus, FormControlDirective], styles: [".custom_grid_size[_ngcontent-%COMP%]{min-width:100px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomGridNumberRangeFilterComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-custom-grid-number-range-filter',
                templateUrl: './custom-grid-number-range-filter.component.html',
                styleUrls: ['./custom-grid-number-range-filter.component.scss']
            }]
    }], function () { return [{ type: SmartTableBackendWrapperConfigService }]; }, null); })();

function CustomGridDateRangeFilterComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 6);
    ɵɵelementStart(1, "div", 7);
    ɵɵlistener("click", function CustomGridDateRangeFilterComponent_div_4_Template_div_click_1_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.overlayClick($event); });
    ɵɵelementStart(2, "div", 8);
    ɵɵlistener("click", function CustomGridDateRangeFilterComponent_div_4_Template_div_click_2_listener($event) { ɵɵrestoreView(_r3); return $event.stopPropagation(); });
    ɵɵelementStart(3, "nb-calendar-range", 9);
    ɵɵlistener("rangeChange", function CustomGridDateRangeFilterComponent_div_4_Template_nb_calendar_range_rangeChange_3_listener($event) { ɵɵrestoreView(_r3); const ctx_r5 = ɵɵnextContext(); return ctx_r5.range = $event; })("rangeChange", function CustomGridDateRangeFilterComponent_div_4_Template_nb_calendar_range_rangeChange_3_listener($event) { ɵɵrestoreView(_r3); const ctx_r6 = ɵɵnextContext(); return ctx_r6.rangeChangeHandler($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("range", ctx_r0.range);
} }
function CustomGridDateRangeFilterComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 10);
    ɵɵlistener("click", function CustomGridDateRangeFilterComponent_div_5_Template_div_click_0_listener() { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(); return ctx_r7.clearRange(); });
    ɵɵelement(1, "i", 11);
    ɵɵelementEnd();
} }
const moment = moment_;
class CustomGridDateRangeFilterComponent extends DefaultFilter {
    constructor(configService) {
        super();
        this.configService = configService;
        this.inputRange = new FormControl(null);
        this.isOpen = false;
        this.isRangeSet = false;
        this.viewMode = NbCalendarViewMode;
    }
    ngOnInit() {
        this.rangePlaceholder = this.configService.getCustomTranslates().filtering.date_range.placeholder;
    }
    ngOnChanges(changes) {
    }
    ngOnDestroy() {
    }
    rangeChangeHandler(event) {
        console.log(event);
        if (event.start && event.end) {
            this.setInputValues(moment(event.start).startOf('day').toISOString(), moment(event.end).startOf('day').toISOString());
            this.isOpen = false;
            this.isRangeSet = true;
        }
    }
    setInputValues(rangeFrom, rangeTo) {
        this.inputRange.setValue(`${moment(rangeFrom).format('DD.MM.YYYY')}-${moment(rangeTo).format('DD.MM.YYYY')}`);
        this.query = [rangeFrom, rangeTo].join('_');
        this.setFilter();
    }
    clearRange() {
        if (this.inputRange.value && this.inputRange.value.length > 0) {
            this.isRangeSet = false;
            this.query = '';
            this.inputRange.reset();
            this.setFilter();
        }
    }
    overlayClick(event) {
        this.isOpen = false;
    }
}
/** @nocollapse */ CustomGridDateRangeFilterComponent.ɵfac = function CustomGridDateRangeFilterComponent_Factory(t) { return new (t || CustomGridDateRangeFilterComponent)(ɵɵdirectiveInject(SmartTableBackendWrapperConfigService)); };
/** @nocollapse */ CustomGridDateRangeFilterComponent.ɵcmp = ɵɵdefineComponent({ type: CustomGridDateRangeFilterComponent, selectors: [["ngx-custom-grid-date-range-filter"]], features: [ɵɵInheritDefinitionFeature, ɵɵNgOnChangesFeature], decls: 6, vars: 4, consts: [[1, "row", "no-gutters", "custom_grid_size"], [1, "col-12"], [1, "position-relative"], ["type", "text", "readOnly", "", 1, "form-control", "date_input", 3, "formControl", "placeholder", "click"], ["class", "datepicker_overlay", 4, "ngIf"], ["class", "clear_filter_button", 3, "click", 4, "ngIf"], [1, "datepicker_overlay"], [1, "datepicker_holder", 3, "click"], ["id", "datepicker", 1, "datepicker", 3, "click"], [3, "range", "rangeChange"], [1, "clear_filter_button", 3, "click"], [1, "fas", "fa-times", "text-danger"]], template: function CustomGridDateRangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("click", function CustomGridDateRangeFilterComponent_Template_input_click_3_listener() { return ctx.isOpen = true; });
        ɵɵelementEnd();
        ɵɵtemplate(4, CustomGridDateRangeFilterComponent_div_4_Template, 4, 1, "div", 4);
        ɵɵtemplate(5, CustomGridDateRangeFilterComponent_div_5_Template, 2, 0, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵproperty("formControl", ctx.inputRange)("placeholder", ctx.rangePlaceholder);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isOpen);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isRangeSet);
    } }, directives: [DefaultValueAccessor, NgControlStatus, FormControlDirective, NgIf, NbCalendarRangeComponent], styles: [".custom_grid_size[_ngcontent-%COMP%]{min-width:100px}.date_input[_ngcontent-%COMP%]{z-index:1}.datepicker_overlay[_ngcontent-%COMP%]{background:rgba(0,0,0,.3);display:flex;height:100%;left:0;position:fixed;top:0;width:100%;z-index:10}.datepicker_overlay[_ngcontent-%COMP%]   .datepicker_holder[_ngcontent-%COMP%]{display:flex;height:100%;position:relative;width:100%}.datepicker_overlay[_ngcontent-%COMP%]   .datepicker_holder[_ngcontent-%COMP%]   .datepicker[_ngcontent-%COMP%]{margin:auto;z-index:10}.date_input_hidden[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;visibility:hidden;width:100%;z-index:0}.form-control[readonly][_ngcontent-%COMP%]{background-color:transparent}.clear_filter_button[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex;height:100%;justify-content:center;padding-right:8px;position:absolute;right:0;top:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomGridDateRangeFilterComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-custom-grid-date-range-filter',
                templateUrl: './custom-grid-date-range-filter.component.html',
                styleUrls: ['./custom-grid-date-range-filter.component.scss']
            }]
    }], function () { return [{ type: SmartTableBackendWrapperConfigService }]; }, null); })();

// FILTERING

class CustomGridActiveStatusColumnComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
/** @nocollapse */ CustomGridActiveStatusColumnComponent.ɵfac = function CustomGridActiveStatusColumnComponent_Factory(t) { return new (t || CustomGridActiveStatusColumnComponent)(); };
/** @nocollapse */ CustomGridActiveStatusColumnComponent.ɵcmp = ɵɵdefineComponent({ type: CustomGridActiveStatusColumnComponent, selectors: [["ngx-custom-grid-active-status-column"]], inputs: { value: "value", rowData: "rowData" }, decls: 2, vars: 2, consts: [[1, "state_indicator", "text-center"], [1, "indicator", "d-inline-block"]], template: function CustomGridActiveStatusColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "div", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵclassProp("active", ctx.value);
    } }, styles: ["[_nghost-%COMP%]   .indicator[_ngcontent-%COMP%]{background-color:var(--color-danger-default);border-radius:100%;height:15px;width:15px}[_nghost-%COMP%]   .indicator.active[_ngcontent-%COMP%]{background-color:var(--color-success-default)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomGridActiveStatusColumnComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-custom-grid-active-status-column',
                templateUrl: './custom-grid-active-status-column.component.html',
                styleUrls: ['./custom-grid-active-status-column.component.scss']
            }]
    }], function () { return []; }, { value: [{
            type: Input
        }], rowData: [{
            type: Input
        }] }); })();

const _c0 = function (a0) { return { cursor: a0 }; };
class CustomGridAvatarColumnComponent {
    constructor() {
        this.clickColumnEvent = new EventEmitter();
    }
    ngOnInit() {
    }
    componentClickAction() {
        if (this.enableClickAction)
            this.clickColumnEvent.emit(this.rowData);
    }
}
/** @nocollapse */ CustomGridAvatarColumnComponent.ɵfac = function CustomGridAvatarColumnComponent_Factory(t) { return new (t || CustomGridAvatarColumnComponent)(); };
/** @nocollapse */ CustomGridAvatarColumnComponent.ɵcmp = ɵɵdefineComponent({ type: CustomGridAvatarColumnComponent, selectors: [["ngx-custom-grid-avatar"]], inputs: { value: "value", rowData: "rowData", enableClickAction: "enableClickAction" }, outputs: { clickColumnEvent: "clickColumnEvent" }, decls: 2, vars: 4, consts: [[1, ""], ["size", "large", "onlyPicture", "", 3, "picture", "ngStyle", "click"]], template: function CustomGridAvatarColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "nb-user", 1);
        ɵɵlistener("click", function CustomGridAvatarColumnComponent_Template_nb_user_click_1_listener() { return ctx.componentClickAction(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("picture", ctx.value && ctx.value.length > 0 ? ctx.value : "./assets/hakoo/favicon.png")("ngStyle", ɵɵpureFunction1(2, _c0, ctx.enableClickAction ? "pointer" : "default"));
    } }, directives: [NbUserComponent, NgStyle], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomGridAvatarColumnComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-custom-grid-avatar',
                templateUrl: './custom-grid-avatar-column.component.html',
                styleUrls: ['./custom-grid-avatar-column.component.scss']
            }]
    }], function () { return []; }, { value: [{
            type: Input
        }], rowData: [{
            type: Input
        }], enableClickAction: [{
            type: Input
        }], clickColumnEvent: [{
            type: Output
        }] }); })();

class CustomGridClickActionColumnComponent {
    constructor() {
        this.clickColumnEvent = new EventEmitter();
    }
    ngOnInit() {
    }
    componentClickAction() {
        this.clickColumnEvent.emit(this.rowData);
    }
}
/** @nocollapse */ CustomGridClickActionColumnComponent.ɵfac = function CustomGridClickActionColumnComponent_Factory(t) { return new (t || CustomGridClickActionColumnComponent)(); };
/** @nocollapse */ CustomGridClickActionColumnComponent.ɵcmp = ɵɵdefineComponent({ type: CustomGridClickActionColumnComponent, selectors: [["ngx-custom-grid-click-action-column"]], inputs: { columnText: "columnText" }, outputs: { clickColumnEvent: "clickColumnEvent" }, decls: 1, vars: 1, consts: [[1, "link-url", 3, "innerHTML", "click"]], template: function CustomGridClickActionColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "a", 0);
        ɵɵlistener("click", function CustomGridClickActionColumnComponent_Template_a_click_0_listener() { return ctx.componentClickAction(); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("innerHTML", ctx.columnText ? ctx.columnText : ctx.value, ɵɵsanitizeHtml);
    } }, styles: ["[_nghost-%COMP%]   .link-url[_ngcontent-%COMP%]{color:var(--link-color);cursor:pointer;display:flex}[_nghost-%COMP%]   .link-url[_ngcontent-%COMP%]  i{margin:auto}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomGridClickActionColumnComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-custom-grid-click-action-column',
                templateUrl: './custom-grid-click-action-column.component.html',
                styleUrls: ['./custom-grid-click-action-column.component.scss']
            }]
    }], function () { return []; }, { columnText: [{
            type: Input
        }], clickColumnEvent: [{
            type: Output
        }] }); })();

// COLUMNS

const moment$1 = moment_;
class CustomGridDateEditorComponent extends DefaultEditor {
    constructor() {
        super();
        this.inputDate = new FormControl(null);
    }
    ngOnInit() {
        if (this.cell.getValue()) {
            this.inputDate.setValue(moment$1(this.cell.getValue(), 'DD.MM.Y'));
        }
    }
    ngAfterViewInit() {
    }
    updateDate(event) {
        console.log(event);
        console.log(this.inputDate.value);
        this.cell.newValue = event.format('DD.MM.Y');
    }
}
/** @nocollapse */ CustomGridDateEditorComponent.ɵfac = function CustomGridDateEditorComponent_Factory(t) { return new (t || CustomGridDateEditorComponent)(); };
/** @nocollapse */ CustomGridDateEditorComponent.ɵcmp = ɵɵdefineComponent({ type: CustomGridDateEditorComponent, selectors: [["ngx-custom-grid-date-editor"]], features: [ɵɵInheritDefinitionFeature], decls: 5, vars: 3, consts: [[1, "row", "no-gutters", "custom_grid_size"], [1, "col-12"], ["type", "text", "id", "inputFrom", "readOnly", "", 1, "form-control", "custom_editor_date", 3, "formControl", "nbDatepicker"], [3, "format", "dateChange"], ["pickerFrom", ""]], template: function CustomGridDateEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "input", 2);
        ɵɵelementStart(3, "nb-datepicker", 3, 4);
        ɵɵlistener("dateChange", function CustomGridDateEditorComponent_Template_nb_datepicker_dateChange_3_listener($event) { return ctx.updateDate($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(4);
        ɵɵadvance(2);
        ɵɵproperty("formControl", ctx.inputDate)("nbDatepicker", _r0);
        ɵɵadvance(1);
        ɵɵproperty("format", "DD.MM.Y");
    } }, directives: [DefaultValueAccessor, NbDatepickerDirective, NgControlStatus, FormControlDirective, NbDatepickerComponent], styles: [".form-control[readonly][_ngcontent-%COMP%]{background-color:transparent}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomGridDateEditorComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-custom-grid-date-editor',
                templateUrl: './custom-grid-date-editor.component.html',
                styleUrls: ['./custom-grid-date-editor.component.scss']
            }]
    }], function () { return []; }, null); })();

// EDITORS

const _c0$1 = ["*"];
class GridConfigHolderComponent {
    constructor() { }
    ngOnInit() {
    }
}
/** @nocollapse */ GridConfigHolderComponent.ɵfac = function GridConfigHolderComponent_Factory(t) { return new (t || GridConfigHolderComponent)(); };
/** @nocollapse */ GridConfigHolderComponent.ɵcmp = ɵɵdefineComponent({ type: GridConfigHolderComponent, selectors: [["stbw-grid-config-holder"]], ngContentSelectors: _c0$1, decls: 1, vars: 0, template: function GridConfigHolderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵprojection(0);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridConfigHolderComponent, [{
        type: Component,
        args: [{
                selector: 'stbw-grid-config-holder',
                templateUrl: './grid-config-holder.component.html',
                styleUrls: ['./grid-config-holder.component.css']
            }]
    }], function () { return []; }, null); })();

const GRID_SETTINGS_DATA = new InjectionToken('GRID_SETTINGS_DATA');

function GridConfigDialogComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "nb-checkbox", 4);
    ɵɵlistener("checkedChange", function GridConfigDialogComponent_div_4_Template_nb_checkbox_checkedChange_1_listener($event) { ɵɵrestoreView(_r3); const column_r1 = ctx.$implicit; const ctx_r2 = ɵɵnextContext(); return ctx_r2.customizeGridColumn($event, column_r1); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 5);
    ɵɵelement(4, "i", 6);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const column_r1 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("checked", !column_r1.hide);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", column_r1.title, " ");
} }
class GridConfigDialogComponent {
    constructor() {
        this.gridColumnsArray = [];
        this.gridSettingsChanged = new EventEmitter();
    }
    set gridSettingsData(gridSettings) {
        this.gridSettings = gridSettings;
        Object.keys(this.gridSettings.columns)
            .sort((a, b) => {
            return this.gridSettings.columns[a].order - this.gridSettings.columns[b].order;
        }).forEach(key => {
            this.gridColumnsArray.push(this.gridSettings.columns[key]);
        });
    }
    ngOnInit() {
    }
    /* public originalOrder(a: KeyValue<string, any>, b: KeyValue<string, any>): number {
       console.log(a.key);
       console.log(a.value);
       console.log(b.key);
       console.log(b.value);
       return a.value.order - b.value.order;
     }*/
    close() {
        this.overlayRef.detach();
    }
    drop(event) {
        moveItemInArray(this.gridColumnsArray, event.previousIndex, event.currentIndex);
        this.gridColumnsArray.forEach((item, index) => {
            item.order = index;
        });
        this.gridSettingsChanged.emit(this.gridSettings);
    }
    customizeGridColumn(event, column) {
        column.hide = !event;
        this.gridSettingsChanged.emit(this.gridSettings);
    }
}
/** @nocollapse */ GridConfigDialogComponent.ɵfac = function GridConfigDialogComponent_Factory(t) { return new (t || GridConfigDialogComponent)(); };
/** @nocollapse */ GridConfigDialogComponent.ɵcmp = ɵɵdefineComponent({ type: GridConfigDialogComponent, selectors: [["lib-grid-config-dialog"]], inputs: { gridSettingsData: ["gridSettings", "gridSettingsData"] }, outputs: { gridSettingsChanged: "gridSettingsChanged" }, decls: 5, vars: 1, consts: [[1, "example-list"], ["cdkDropList", "", 1, "row", "no-gutters", 3, "cdkDropListDropped"], ["class", "col-12 d-flex example-box", "cdkDrag", "", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "col-12", "d-flex", "example-box"], [3, "checked", "checkedChange"], ["cdkDragHandle", "", 1, "dragable_item"], [1, "fas", "fa-arrows-alt-v"]], template: function GridConfigDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "nb-card");
        ɵɵelementStart(1, "nb-card-body");
        ɵɵelementStart(2, "div", 0);
        ɵɵelementStart(3, "div", 1);
        ɵɵlistener("cdkDropListDropped", function GridConfigDialogComponent_Template_div_cdkDropListDropped_3_listener($event) { return ctx.drop($event); });
        ɵɵtemplate(4, GridConfigDialogComponent_div_4_Template, 5, 2, "div", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("ngForOf", ctx.gridColumnsArray);
    } }, directives: [NbCardComponent, NbCardBodyComponent, CdkDropList, NgForOf, CdkDrag, NbCheckboxComponent, CdkDragHandle], styles: ["[_nghost-%COMP%]{margin:auto}.example-list[_ngcontent-%COMP%]{background:#fff;border:1px solid #ccc;border-radius:4px;display:block;max-width:100%;min-height:40px;overflow:hidden;width:500px}.example-box[_ngcontent-%COMP%]{align-items:center;background:#fff;border-bottom:1px solid #ccc;box-sizing:border-box;color:rgba(0,0,0,.87);display:flex;flex-direction:row;justify-content:space-between;padding:0 .5rem}.dragable_item[_ngcontent-%COMP%]{cursor:move}.cdk-drag-preview[_ngcontent-%COMP%]{border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box;position:fixed;z-index:10000!important}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:0}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-box[_ngcontent-%COMP%]:last-child{border:none}.example-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   .example-box[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridConfigDialogComponent, [{
        type: Component,
        args: [{
                selector: 'lib-grid-config-dialog',
                templateUrl: './grid-config-dialog.component.html',
                styleUrls: ['./grid-config-dialog.component.css']
            }]
    }], function () { return []; }, { data: [{
            type: Inject,
            args: [GRID_SETTINGS_DATA]
        }], gridSettingsData: [{
            type: Input,
            args: ['gridSettings']
        }], gridSettingsChanged: [{
            type: Output
        }] }); })();

class GridConfigButtonComponent {
    constructor(overlay, injector) {
        this.overlay = overlay;
        this.injector = injector;
        this.gridSettingsChange = new EventEmitter();
    }
    ngOnInit() {
    }
    openConfigDialog() {
        const positionStrategy = this.overlay
            .position().global();
        const overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            panelClass: 'm-auto'
        });
        const userProfilePortal = new ComponentPortal(GridConfigDialogComponent);
        const componentRef = overlayRef.attach(userProfilePortal);
        componentRef.instance.gridSettingsData = this.settings;
        componentRef.instance.gridSettingsChanged
            .subscribe(change => {
            this.gridSettingsChange.emit(change);
        });
        const sub = overlayRef
            .backdropClick().subscribe(() => {
            overlayRef.detach();
            sub.unsubscribe();
        });
    }
    createInjector(data, overlayRef) {
        const injectorTokens = new WeakMap();
        injectorTokens.set(OverlayRef, overlayRef);
        injectorTokens.set(GRID_SETTINGS_DATA, data);
        return new PortalInjector(this.injector, injectorTokens);
    }
}
/** @nocollapse */ GridConfigButtonComponent.ɵfac = function GridConfigButtonComponent_Factory(t) { return new (t || GridConfigButtonComponent)(ɵɵdirectiveInject(Overlay), ɵɵdirectiveInject(Injector)); };
/** @nocollapse */ GridConfigButtonComponent.ɵcmp = ɵɵdefineComponent({ type: GridConfigButtonComponent, selectors: [["lib-grid-config-button"]], inputs: { settings: ["gridSettings", "settings"] }, outputs: { gridSettingsChange: "gridSettingsChange" }, decls: 2, vars: 0, consts: [["type", "button", "ghost", "", "size", "small", "nbButton", "", 3, "click"], [1, "fas", "fa-cog"]], template: function GridConfigButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "button", 0);
        ɵɵlistener("click", function GridConfigButtonComponent_Template_button_click_0_listener() { return ctx.openConfigDialog(); });
        ɵɵelement(1, "i", 1);
        ɵɵelementEnd();
    } }, directives: [NbButtonComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridConfigButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-grid-config-button',
                templateUrl: './grid-config-button.component.html',
                styleUrls: ['./grid-config-button.component.css']
            }]
    }], function () { return [{ type: Overlay }, { type: Injector }]; }, { settings: [{
            type: Input,
            args: ['gridSettings']
        }], gridSettingsChange: [{
            type: Output
        }] }); })();

function PaginatorComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 3);
    ɵɵlistener("click", function PaginatorComponent_div_9_Template_div_click_0_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.pagerPrevPage(); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.paginator.current_page - 1);
} }
function PaginatorComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 3);
    ɵɵlistener("click", function PaginatorComponent_div_13_Template_div_click_0_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.pagerNextPage(); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r1.paginator.current_page + 1);
} }
var PAGINATOR_EVENT;
(function (PAGINATOR_EVENT) {
    PAGINATOR_EVENT["PAGE_CHANGE_EVENT"] = "paginatorChangeEvent";
    PAGINATOR_EVENT["PER_PAGE_CHANGE"] = "perPage";
})(PAGINATOR_EVENT || (PAGINATOR_EVENT = {}));
class PaginatorComponent {
    constructor() {
        this.paginatorChangeEvent = new EventEmitter();
    }
    set perPageItems(data) {
        this.perPage = data;
    }
    ngOnInit() {
    }
    setPerPage(itemsCount) {
        this.paginatorChangeEvent.emit({ event: PAGINATOR_EVENT.PER_PAGE_CHANGE, data: itemsCount });
    }
    pagerNextPage() {
        // if (this.actualPage < this.pageCount) {
        this.paginatorChangeEvent.emit({ event: PAGINATOR_EVENT.PAGE_CHANGE_EVENT, data: this.paginator.current_page + 1 });
        // }
    }
    pagerPrevPage() {
        // if (this.actualPage > 1) {
        this.paginatorChangeEvent.emit({ event: PAGINATOR_EVENT.PAGE_CHANGE_EVENT, data: this.paginator.current_page - 1 });
        // }
    }
    pagerFirstPage() {
        this.paginatorChangeEvent.emit({ event: PAGINATOR_EVENT.PAGE_CHANGE_EVENT, data: 1 });
    }
    pagerLastPage() {
        this.paginatorChangeEvent.emit({ event: PAGINATOR_EVENT.PAGE_CHANGE_EVENT, data: this.paginator.last_page });
    }
}
/** @nocollapse */ PaginatorComponent.ɵfac = function PaginatorComponent_Factory(t) { return new (t || PaginatorComponent)(); };
/** @nocollapse */ PaginatorComponent.ɵcmp = ɵɵdefineComponent({ type: PaginatorComponent, selectors: [["stbw-paginator"]], inputs: { pageCount: "pageCount", actualPage: "actualPage", paginator: "paginator", perPageItems: ["perPage", "perPageItems"] }, outputs: { paginatorChangeEvent: "paginatorChangeEvent" }, decls: 30, vars: 20, consts: [[1, "row", "no-gutters", "pt-3", "justify-content-center", "justify-content-md-between"], [1, "col-auto", "mx-auto"], [1, "paginator_holder", "d-flex"], [1, "paginator_item", 3, "click"], ["class", "paginator_item", 3, "click", 4, "ngIf"], [1, "paginator_item", "active"], [1, "col-auto"], [1, "per_page_items_holder", "d-flex"], [1, "per_page", 3, "click"]], template: function PaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_3_listener() { return ctx.pagerFirstPage(); });
        ɵɵelementStart(4, "span");
        ɵɵtext(5, "\u00AB");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 3);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_6_listener() { return ctx.pagerPrevPage(); });
        ɵɵelementStart(7, "span");
        ɵɵtext(8, "<");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(9, PaginatorComponent_div_9_Template, 3, 1, "div", 4);
        ɵɵelementStart(10, "div", 5);
        ɵɵelementStart(11, "span");
        ɵɵtext(12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(13, PaginatorComponent_div_13_Template, 3, 1, "div", 4);
        ɵɵelementStart(14, "div", 3);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_14_listener() { return ctx.pagerNextPage(); });
        ɵɵelementStart(15, "span");
        ɵɵtext(16, ">");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", 3);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_17_listener() { return ctx.pagerLastPage(); });
        ɵɵelementStart(18, "span");
        ɵɵtext(19, "\u00BB");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(20, "div", 6);
        ɵɵelementStart(21, "div", 7);
        ɵɵelementStart(22, "div", 8);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_22_listener() { return ctx.setPerPage(10); });
        ɵɵtext(23, " 10 ");
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 8);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_24_listener() { return ctx.setPerPage(25); });
        ɵɵtext(25, " 25 ");
        ɵɵelementEnd();
        ɵɵelementStart(26, "div", 8);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_26_listener() { return ctx.setPerPage(50); });
        ɵɵtext(27, " 50 ");
        ɵɵelementEnd();
        ɵɵelementStart(28, "div", 8);
        ɵɵlistener("click", function PaginatorComponent_Template_div_click_28_listener() { return ctx.setPerPage(100); });
        ɵɵtext(29, " 100 ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(3);
        ɵɵclassProp("disabled", ctx.paginator.current_page === 1);
        ɵɵadvance(3);
        ɵɵclassProp("disabled", ctx.paginator.current_page === 1);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.paginator.current_page - 1 > 0);
        ɵɵadvance(3);
        ɵɵtextInterpolate2("", ctx.paginator.current_page, "/", ctx.paginator.last_page, "");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.paginator.current_page + 1 <= ctx.paginator.last_page);
        ɵɵadvance(1);
        ɵɵclassProp("disabled", ctx.paginator.current_page == ctx.paginator.last_page);
        ɵɵadvance(3);
        ɵɵclassProp("disabled", ctx.paginator.current_page == ctx.paginator.last_page);
        ɵɵadvance(5);
        ɵɵclassProp("active", ctx.paginator.per_page == 10);
        ɵɵadvance(2);
        ɵɵclassProp("active", ctx.paginator.per_page == 25);
        ɵɵadvance(2);
        ɵɵclassProp("active", ctx.paginator.per_page == 50);
        ɵɵadvance(2);
        ɵɵclassProp("active", ctx.paginator.per_page == 100);
    } }, directives: [NgIf], styles: [".paginator_holder[_ngcontent-%COMP%], .per_page_items_holder[_ngcontent-%COMP%]{border:2px solid var(--backend-wrapper-pager-border);border-radius:.5rem;margin-bottom:1rem;overflow:hidden}.paginator_item[_ngcontent-%COMP%], .per_page[_ngcontent-%COMP%]{background-color:var(--backend-wrapper-pager-item-background);cursor:pointer;display:inline-block;padding:.75rem 1.25rem;position:relative}.paginator_item.active[_ngcontent-%COMP%], .per_page.active[_ngcontent-%COMP%]{pointer-events:none}.paginator_item.active[_ngcontent-%COMP%], .paginator_item[_ngcontent-%COMP%]:hover, .per_page.active[_ngcontent-%COMP%], .per_page[_ngcontent-%COMP%]:hover{background-color:var(--backend-wrapper-pager-item-background-active);color:var(--backend-wrapper-pager-item-fg-active)}.paginator_item.disabled[_ngcontent-%COMP%], .per_page.disabled[_ngcontent-%COMP%]{background-color:var(--backend-wrapper-pager-item-background-disabled);color:var(--backend-wrapper-pager-item-fg-disabled);pointer-events:none}.paginator_item[_ngcontent-%COMP%]:not(:last-child), .per_page[_ngcontent-%COMP%]:not(:last-child){border-color:var(--border-basic-color-3);border-right:1px solid var(--backend-wrapper-pager-border)}.per_page_items_holder[_ngcontent-%COMP%]{margin-bottom:1rem;right:0;z-index:1}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PaginatorComponent, [{
        type: Component,
        args: [{
                selector: 'stbw-paginator',
                templateUrl: './paginator.component.html',
                styleUrls: ['./paginator.component.scss']
            }]
    }], function () { return []; }, { pageCount: [{
            type: Input,
            args: ['pageCount']
        }], actualPage: [{
            type: Input,
            args: ['actualPage']
        }], paginator: [{
            type: Input,
            args: ['paginator']
        }], perPageItems: [{
            type: Input,
            args: ['perPage']
        }], paginatorChangeEvent: [{
            type: Output
        }] }); })();

class SmartTableWrapperExportTableService {
    constructor() {
    }
    exportCSV(tableSettings, tableData, customizedSettings) {
        const columnsSettings = tableSettings.columns;
        const headerTitles = [];
        const columnsSettingsKeys = Object.keys(columnsSettings);
        columnsSettingsKeys.forEach(key => {
            if (!columnsSettings[key].suppressCsvExport && key in customizedSettings.columns) {
                headerTitles.push(columnsSettings[key].title);
            }
        });
        const csvExporter = new ExportToCsv(this.getCSVExportOptions(headerTitles, tableSettings));
        tableData.getAll().then(res => {
            const formattedData = [];
            res.forEach(dataRow => {
                const rowFormattedData = [];
                columnsSettingsKeys.forEach(columnSettingKey => {
                    const actualColumnSetting = columnsSettings[columnSettingKey];
                    if (columnSettingKey in customizedSettings.columns) {
                        if ('csvExportPrepareFunction' in actualColumnSetting) {
                            rowFormattedData.push(actualColumnSetting.csvExportPrepareFunction(dataRow[columnSettingKey], dataRow));
                        }
                        else {
                            if ('valuePrepareFunction' in actualColumnSetting) {
                                rowFormattedData.push(actualColumnSetting.valuePrepareFunction(dataRow[columnSettingKey], dataRow));
                            }
                            else {
                                rowFormattedData.push(dataRow[columnSettingKey]);
                            }
                        }
                    }
                });
                formattedData.push(rowFormattedData);
            });
            csvExporter.generateCsv(formattedData, false);
        });
    }
    getCSVExportOptions(headerTitles, settings) {
        const date = new Date();
        return {
            fieldSeparator: ';',
            quoteStrings: '"',
            decimalSeparator: ',',
            showLabels: true,
            // showTitle: true,
            // title: 'CSV export',
            useTextFile: false,
            useBom: true,
            filename: settings.csvExportName ? `${settings.csvExportName}_${this.getFileTimestamp(date)}` : this.getFileTimestamp(date),
            // useKeysAsHeaders: true,
            headers: headerTitles
        };
    }
    getFileTimestamp(date) {
        return `${date.toLocaleDateString()}_${date.toLocaleTimeString()}`;
    }
}
/** @nocollapse */ SmartTableWrapperExportTableService.ɵfac = function SmartTableWrapperExportTableService_Factory(t) { return new (t || SmartTableWrapperExportTableService)(); };
/** @nocollapse */ SmartTableWrapperExportTableService.ɵprov = ɵɵdefineInjectable({ token: SmartTableWrapperExportTableService, factory: SmartTableWrapperExportTableService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SmartTableWrapperExportTableService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class GridExportButtonComponent {
    constructor(exportService) {
        this.exportService = exportService;
        this.customizedSettings = {};
    }
    ngOnInit() {
    }
    exportCSV() {
        console.log('export');
        this.exportService.exportCSV(this.settings, this.source, this.customizedSettings);
    }
}
/** @nocollapse */ GridExportButtonComponent.ɵfac = function GridExportButtonComponent_Factory(t) { return new (t || GridExportButtonComponent)(ɵɵdirectiveInject(SmartTableWrapperExportTableService)); };
/** @nocollapse */ GridExportButtonComponent.ɵcmp = ɵɵdefineComponent({ type: GridExportButtonComponent, selectors: [["lib-grid-export-button"]], inputs: { settings: "settings", customizedSettings: "customizedSettings", source: "source" }, decls: 2, vars: 0, consts: [["type", "button", "ghost", "", "size", "small", "nbButton", "", 3, "click"], [1, "fas", "fa-download"]], template: function GridExportButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "button", 0);
        ɵɵlistener("click", function GridExportButtonComponent_Template_button_click_0_listener() { return ctx.exportCSV(); });
        ɵɵelement(1, "i", 1);
        ɵɵelementEnd();
    } }, directives: [NbButtonComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GridExportButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-grid-export-button',
                templateUrl: './grid-export-button.component.html',
                styleUrls: ['./grid-export-button.component.css']
            }]
    }], function () { return [{ type: SmartTableWrapperExportTableService }]; }, { settings: [{
            type: Input
        }], customizedSettings: [{
            type: Input
        }], source: [{
            type: Input
        }] }); })();

function SmartTableBackendWrapperComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 5);
    ɵɵelement(1, "lib-grid-export-button", 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("settings", ctx_r0.settings)("customizedSettings", ctx_r0.customizedSettings)("source", ctx_r0.source);
} }
const _c0$2 = [[["stbw-grid-config-holder"]]];
const _c1 = ["stbw-grid-config-holder"];
class SmartTableBackendWrapperComponent extends ɵbo {
    constructor() {
        super();
        this.customizedSettings = {};
        this.paginatorChangeEvent = new EventEmitter();
        this.edit = new EventEmitter();
        this.delete = new EventEmitter();
        this.create = new EventEmitter();
        this.editConfirm = new EventEmitter();
        this.deleteConfirm = new EventEmitter();
        this.createConfirm = new EventEmitter();
        this.custom = new EventEmitter();
    }
    // ORIGINAL SMART TABLE
    set settingsData(settings) {
        if (settings) {
            this.settings = settings;
            this.setInitialColumnsOrder(this.settings.columns);
            this.getLocalStorageSettings();
            if (settings.localStorageId) {
                this.customizedSettings = {};
                this.copySettings(this.customizedSettings, this.settings);
                this.setSettings(this.settings);
            }
            else {
                this.copySettings(this.customizedSettings, this.settings);
            }
        }
    }
    ngOnInit() {
    }
    paginatorChange(event) {
        this.paginatorChangeEvent.emit(event);
    }
    setSettings(settings) {
        this.customizedSettings.columns = {};
        Object.keys(settings.columns).sort((a, b) => {
            return settings.columns[a].order - settings.columns[b].order;
        }).forEach(column => {
            if (settings.columns[column].hide) {
                delete this.customizedSettings.columns[column];
            }
            else {
                this.customizedSettings.columns[column] = settings.columns[column];
                // this.copySettings(this.customizedSettings.columns[column], settings.columns[column]);
            }
        });
        this.setLocalStorageSettings(settings.columns);
        this.customizedSettings = Object.assign({}, this.customizedSettings);
    }
    setInitialColumnsOrder(columns) {
        Object.keys(columns).forEach((columnKey, index) => {
            columns[columnKey].order = index;
        });
    }
    copySettings(object, newObjectData) {
        Object.keys(newObjectData).forEach(key => {
            if (newObjectData[key] instanceof Object) {
                object[key] = Object.assign({}, newObjectData[key]);
            }
            else {
                object[key] = newObjectData[key];
            }
        });
    }
    getLocalStorageSettings() {
        if (this.settings.localStorageId) {
            const columns = localStorage.getItem(this.settings.localStorageId);
            if (columns) {
                try {
                    JSON.parse(columns).forEach(column => {
                        if (this.settings.columns[column.key]) {
                            this.settings.columns[column.key].hide = column.hide;
                            this.settings.columns[column.key].order = column.order;
                        }
                    });
                }
                catch (e) {
                }
            }
        }
    }
    setLocalStorageSettings(settingsColumns) {
        if (this.settings.localStorageId) {
            const localStorageArray = [];
            Object.keys(settingsColumns).forEach(key => {
                localStorageArray.push({
                    key,
                    hide: settingsColumns[key].hide,
                    order: settingsColumns[key].order
                });
            });
            localStorage.setItem(this.settings.localStorageId, JSON.stringify(localStorageArray));
        }
    }
}
/** @nocollapse */ SmartTableBackendWrapperComponent.ɵfac = function SmartTableBackendWrapperComponent_Factory(t) { return new (t || SmartTableBackendWrapperComponent)(); };
/** @nocollapse */ SmartTableBackendWrapperComponent.ɵcmp = ɵɵdefineComponent({ type: SmartTableBackendWrapperComponent, selectors: [["stbw-grid"]], inputs: { isLoading: "isLoading", filteringObject: "filteringObject", settingsData: ["settings", "settingsData"], source: "source" }, outputs: { paginatorChangeEvent: "paginatorChangeEvent", edit: "edit", delete: "delete", create: "create", editConfirm: "editConfirm", deleteConfirm: "deleteConfirm", createConfirm: "createConfirm", custom: "custom" }, features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 11, vars: 7, consts: [[1, "row"], [1, "col-12"], [1, "row", "justify-content-end", "no-gutters"], [1, "col-auto", "d-flex"], ["class", "col-auto", 4, "ngIf"], [1, "col-auto"], [3, "gridSettings", "gridSettingsChange"], [2, "overflow", "auto", "z-index", "1", "position", "relative", 3, "nbSpinner", "nbSpinnerMessage", "nbSpinnerStatus"], [3, "settings", "source", "edit", "delete", "create", "editConfirm", "deleteConfirm", "createConfirm", "custom"], [3, "paginator", "paginatorChangeEvent"], [3, "settings", "customizedSettings", "source"]], template: function SmartTableBackendWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef(_c0$2);
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵprojection(4);
        ɵɵelementEnd();
        ɵɵtemplate(5, SmartTableBackendWrapperComponent_div_5_Template, 2, 3, "div", 4);
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "lib-grid-config-button", 6);
        ɵɵlistener("gridSettingsChange", function SmartTableBackendWrapperComponent_Template_lib_grid_config_button_gridSettingsChange_7_listener($event) { return ctx.setSettings($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 7);
        ɵɵelementStart(9, "ng2-smart-table", 8);
        ɵɵlistener("edit", function SmartTableBackendWrapperComponent_Template_ng2_smart_table_edit_9_listener($event) { return ctx.edit.emit($event); })("delete", function SmartTableBackendWrapperComponent_Template_ng2_smart_table_delete_9_listener($event) { return ctx.delete.emit($event); })("create", function SmartTableBackendWrapperComponent_Template_ng2_smart_table_create_9_listener($event) { return ctx.create.emit($event); })("editConfirm", function SmartTableBackendWrapperComponent_Template_ng2_smart_table_editConfirm_9_listener($event) { return ctx.editConfirm.emit($event); })("deleteConfirm", function SmartTableBackendWrapperComponent_Template_ng2_smart_table_deleteConfirm_9_listener($event) { return ctx.deleteConfirm.emit($event); })("createConfirm", function SmartTableBackendWrapperComponent_Template_ng2_smart_table_createConfirm_9_listener($event) { return ctx.createConfirm.emit($event); })("custom", function SmartTableBackendWrapperComponent_Template_ng2_smart_table_custom_9_listener($event) { return ctx.custom.emit($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "stbw-paginator", 9);
        ɵɵlistener("paginatorChangeEvent", function SmartTableBackendWrapperComponent_Template_stbw_paginator_paginatorChangeEvent_10_listener($event) { return ctx.paginatorChange($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵproperty("ngIf", !ctx.settings.supressCsvExport);
        ɵɵadvance(2);
        ɵɵproperty("gridSettings", ctx.settings);
        ɵɵadvance(1);
        ɵɵproperty("nbSpinner", ctx.isLoading)("nbSpinnerStatus", "primary");
        ɵɵadvance(1);
        ɵɵproperty("settings", ctx.customizedSettings)("source", ctx.source);
        ɵɵadvance(1);
        ɵɵproperty("paginator", ctx.filteringObject.paginator);
    } }, directives: [NgIf, GridConfigButtonComponent, NbSpinnerDirective, ɵbo, PaginatorComponent, GridExportButtonComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SmartTableBackendWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'stbw-grid',
                template: `
    <div class="row">
      <div class="col-12">
        <div class="row justify-content-end no-gutters">
          <div class="col-auto d-flex">
            <ng-content select="stbw-grid-config-holder"></ng-content>
          </div>
          <div class="col-auto" *ngIf="!settings.supressCsvExport">
            <lib-grid-export-button
              [settings]="settings"
              [customizedSettings]="customizedSettings"
              [source]="source">
            </lib-grid-export-button>
          </div>
          <div class="col-auto">
            <lib-grid-config-button
              [gridSettings]="settings"
              (gridSettingsChange)="setSettings($event)">
            </lib-grid-config-button>
          </div>
        </div>
        <div [nbSpinner]="isLoading"
             [nbSpinnerMessage]=""
             [nbSpinnerStatus]="'primary'"
             style="overflow: auto; z-index: 1; position: relative"
        >
          <ng2-smart-table
            [settings]="customizedSettings"
            [source]="source"
            (edit)="edit.emit($event)"
            (delete)="delete.emit($event)"
            (create)="create.emit($event)"
            (editConfirm)="editConfirm.emit($event)"
            (deleteConfirm)="deleteConfirm.emit($event)"
            (createConfirm)="createConfirm.emit($event)"
            (custom)="custom.emit($event)"
          >
          </ng2-smart-table>
        </div>
      </div>
    </div>
    <stbw-paginator [paginator]="filteringObject.paginator"
                    (paginatorChangeEvent)="paginatorChange($event)"
    ></stbw-paginator>
  `,
                styles: []
            }]
    }], function () { return []; }, { isLoading: [{
            type: Input
        }], filteringObject: [{
            type: Input
        }], paginatorChangeEvent: [{
            type: Output
        }], settingsData: [{
            type: Input,
            args: ['settings']
        }], source: [{
            type: Input
        }], edit: [{
            type: Output
        }], delete: [{
            type: Output
        }], create: [{
            type: Output
        }], editConfirm: [{
            type: Output
        }], deleteConfirm: [{
            type: Output
        }], createConfirm: [{
            type: Output
        }], custom: [{
            type: Output
        }] }); })();

class TestComponent {
    // @Inject('testProvider') config: any
    //@Inject(CUSTOM_SMART_TABLE_CONFIG) private testConfig: SmartTableBackendWrapperConfig,
    constructor(configService) {
        this.configService = configService;
    }
    ngOnInit() {
        // console.log(this.testConfig);
        console.log(this.configService);
    }
}
/** @nocollapse */ TestComponent.ɵfac = function TestComponent_Factory(t) { return new (t || TestComponent)(ɵɵdirectiveInject(SmartTableBackendWrapperConfigService)); };
/** @nocollapse */ TestComponent.ɵcmp = ɵɵdefineComponent({ type: TestComponent, selectors: [["lib-test"]], decls: 2, vars: 0, template: function TestComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, "test works!");
        ɵɵelementEnd();
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TestComponent, [{
        type: Component,
        args: [{
                selector: 'lib-test',
                templateUrl: './test.component.html',
                styleUrls: ['./test.component.css']
            }]
    }], function () { return [{ type: SmartTableBackendWrapperConfigService }]; }, null); })();

class SmartTableBackendWrapperModule {
    static forRoot(configuration) {
        return {
            ngModule: SmartTableBackendWrapperModule,
            providers: [
                /*  {
                    provide: CUSTOM_SMART_TABLE_CONFIG, useValue: configuration.config
                  },*/
                configuration.configService ? {
                    provide: SmartTableBackendWrapperConfigService,
                    useClass: configuration.configService
                } : SmartTableBackendWrapperConfigService,
            ],
        };
    }
}
/** @nocollapse */ SmartTableBackendWrapperModule.ɵmod = ɵɵdefineNgModule({ type: SmartTableBackendWrapperModule });
/** @nocollapse */ SmartTableBackendWrapperModule.ɵinj = ɵɵdefineInjector({ factory: function SmartTableBackendWrapperModule_Factory(t) { return new (t || SmartTableBackendWrapperModule)(); }, providers: [SmartTableBackendWrapperConfigService,
        NbLayoutDirectionService
        // Overlay,
        // NbOverlayModule
        // {provide: OverlayContainer, useClass: FullscreenOverlayContainer},
    ], imports: [[
            CommonModule,
            Ng2SmartTableModule,
            NbThemeModule,
            OverlayModule,
            DragDropModule,
            ReactiveFormsModule,
            NbInputModule,
            NbCheckboxModule,
            NbDatepickerModule,
            NbMomentDateModule,
            NbCalendarRangeModule,
            NbSpinnerModule,
            NbUserModule,
            NbButtonModule,
            NbCardModule
        ], Ng2SmartTableModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SmartTableBackendWrapperModule, { declarations: [SmartTableBackendWrapperComponent,
        PaginatorComponent,
        CustomGridNumberRangeFilterComponent,
        CustomGridDateRangeFilterComponent,
        CustomGridActiveStatusColumnComponent,
        CustomGridClickActionColumnComponent,
        CustomGridAvatarColumnComponent,
        CustomGridDateEditorComponent,
        TestComponent,
        GridConfigDialogComponent,
        GridConfigButtonComponent,
        GridExportButtonComponent,
        GridConfigHolderComponent], imports: [CommonModule,
        Ng2SmartTableModule,
        NbThemeModule,
        OverlayModule,
        DragDropModule,
        ReactiveFormsModule,
        NbInputModule,
        NbCheckboxModule,
        NbDatepickerModule,
        NbMomentDateModule,
        NbCalendarRangeModule,
        NbSpinnerModule,
        NbUserModule,
        NbButtonModule,
        NbCardModule], exports: [SmartTableBackendWrapperComponent,
        Ng2SmartTableModule,
        PaginatorComponent,
        CustomGridNumberRangeFilterComponent,
        CustomGridActiveStatusColumnComponent,
        CustomGridDateRangeFilterComponent,
        CustomGridClickActionColumnComponent,
        CustomGridAvatarColumnComponent,
        CustomGridDateEditorComponent,
        GridConfigHolderComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(SmartTableBackendWrapperModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SmartTableBackendWrapperComponent,
                    PaginatorComponent,
                    CustomGridNumberRangeFilterComponent,
                    CustomGridDateRangeFilterComponent,
                    CustomGridActiveStatusColumnComponent,
                    CustomGridClickActionColumnComponent,
                    CustomGridAvatarColumnComponent,
                    CustomGridDateEditorComponent,
                    TestComponent,
                    GridConfigDialogComponent,
                    GridConfigButtonComponent,
                    GridExportButtonComponent,
                    GridConfigHolderComponent
                ],
                imports: [
                    CommonModule,
                    Ng2SmartTableModule,
                    NbThemeModule,
                    OverlayModule,
                    DragDropModule,
                    ReactiveFormsModule,
                    NbInputModule,
                    NbCheckboxModule,
                    NbDatepickerModule,
                    NbMomentDateModule,
                    NbCalendarRangeModule,
                    NbSpinnerModule,
                    NbUserModule,
                    NbButtonModule,
                    NbCardModule
                ],
                entryComponents: [
                    CustomGridNumberRangeFilterComponent,
                    CustomGridDateRangeFilterComponent,
                    CustomGridActiveStatusColumnComponent,
                    CustomGridClickActionColumnComponent,
                    CustomGridAvatarColumnComponent,
                    CustomGridDateEditorComponent,
                    GridConfigDialogComponent
                ],
                providers: [SmartTableBackendWrapperConfigService,
                    NbLayoutDirectionService
                    // Overlay,
                    // NbOverlayModule
                    // {provide: OverlayContainer, useClass: FullscreenOverlayContainer},
                ],
                exports: [
                    SmartTableBackendWrapperComponent,
                    Ng2SmartTableModule,
                    PaginatorComponent,
                    CustomGridNumberRangeFilterComponent,
                    CustomGridActiveStatusColumnComponent,
                    CustomGridDateRangeFilterComponent,
                    CustomGridClickActionColumnComponent,
                    CustomGridAvatarColumnComponent,
                    CustomGridDateEditorComponent,
                    GridConfigHolderComponent
                ]
            }]
    }], null, null); })();

class BackendFilteringObject {
    constructor(perPage = 10) {
        this.perPage = perPage;
        this.filteringItems = [];
        this.sortingItems = [];
        this.paginatorItem = {};
        this.paginatorItem.current_page = 1;
        this.paginatorItem.per_page = perPage;
        this.paginatorItem.total = 1;
    }
    setFilteringItems(items) {
        this.filteringItems = items;
    }
    setSortingItems(items) {
        this.sortingItems = items;
    }
    get paginator() {
        return this.paginatorItem;
    }
    set perPageItems(items) {
        this.perPage = items;
        this.paginatorItem.per_page = items;
    }
    get perPageItems() {
        return this.paginatorItem.per_page;
    }
    setPager(currentPage, pageCount, perPage, totalItems) {
        this.actualPage = currentPage;
        this.lastPage = pageCount;
        if (perPage) {
            this.paginator.per_page = perPage;
        }
        if (totalItems) {
            this.paginator.total = totalItems;
        }
    }
    setBackendPager(pager) {
        this.paginatorItem = {
            current_page: pager.current_page,
            last_page: pager.last_page,
            per_page: pager.per_page,
            from: pager.from,
            to: pager.to,
            total: pager.total,
        };
    }
    set actualPage(page) {
        this.paginatorItem.current_page = page;
    }
    get actualPage() {
        return this.paginatorItem.current_page;
    }
    set lastPage(pageCount) {
        this.paginatorItem.last_page = pageCount;
    }
    get lastPage() {
        return this.paginatorItem.last_page;
    }
    getFilter() {
        return this.filteringItems
            .map(item => `${item.field}=${item.search}`);
    }
    getSort() {
        return this.sortingItems
            .map(item => `sort=${item.field}.${item.direction}`);
    }
    setFilter(filtering, sorting) {
        this.setFilteringItems(filtering);
        this.setSortingItems(sorting);
    }
    getBackendFiltering() {
        const filterArray = [...this.getFilter(),
            ...this.getSort(),
            'page=' + this.actualPage,
            'limit=' + this.perPageItems];
        return filterArray.join('&');
    }
    resetBackendFiltering() {
        this.filteringItems = [];
        this.sortingItems = [];
        this.paginatorItem.current_page = 1;
        this.paginatorItem.per_page = this.perPage;
    }
}

// @Directive()
// @Directive()
// tslint:disable-next-line:component-class-suffix
class FilteringWrapper {
    constructor() {
        this.source = new LocalDataSource();
        this.filteringObj = new BackendFilteringObject();
        this.loading = true;
        this.autoLoading = true;
        this.isFirstRequestAfterInputFilterChange = false;
        this.subs = [];
    }
    set showGridByFilterValue(filter) {
        if (filter) {
            this.isFirstRequestAfterInputFilterChange = true;
            this.setCustomFilterItemValue(filter);
        }
    }
    // @Input() selectedRowsIds: Set<string>;
    // @Output() onCustomRowSelect: EventEmitter<RowSelectEvent> = new EventEmitter<RowSelectEvent>();
    setCustomFilterItemValue(filter) {
        this.source.addFilter({ field: filter.name, search: filter.value });
    }
    turnOffAutoLoading() {
        this.autoLoading = false;
    }
    initGridCustomization(perPageItems = 10, filter) {
        this.filteringObj.perPageItems = perPageItems;
        this.initFilteringChanges();
        this.setColumns();
        if (this.autoLoading) {
            if (filter) {
                this.setFilter(filter);
            }
            else {
                this.loadData();
            }
        }
    }
    initFilteringChanges() {
        this.subs.push(this.source.onChanged().pipe(distinctUntilChanged()).subscribe((change) => {
            if (change.action === 'filter') {
                const filteringArray = change.filter.filters;
                const sortingArray = change.sort;
                this.filteringObj.setFilter(filteringArray, sortingArray);
                this.filteringObj.actualPage = 1;
                if (!this.isFirstRequestAfterInputFilterChange) {
                    this.loadData();
                }
                else {
                    this.isFirstRequestAfterInputFilterChange = false;
                }
            }
            if (change.action === 'sort') {
                this.settings.columns[change.sort[0].field].sort = false;
                const filteringArray = change.filter.filters;
                const sortingArray = change.sort;
                this.filteringObj.setFilter(filteringArray, sortingArray);
                this.filteringObj.actualPage = 1;
                this.loadData();
            }
        }));
    }
    pageChanged(page) {
        switch (page.event) {
            case (PAGINATOR_EVENT.PAGE_CHANGE_EVENT): {
                this.filteringObj.actualPage = page.data;
                this.loadData();
                break;
            }
            case (PAGINATOR_EVENT.PER_PAGE_CHANGE): {
                this.filteringObj.perPageItems = page.data;
                this.filteringObj.actualPage = 1;
                this.loadData();
            }
        }
    }
    refreshData() {
        this.source.reset();
        this.setColumns();
        this.filteringObj.actualPage = 1;
        this.filteringObj.resetBackendFiltering();
        this.loadData();
    }
    setFilter(filters) {
        this.source.setFilter(filters);
    }
}
/** @nocollapse */ FilteringWrapper.ɵfac = function FilteringWrapper_Factory(t) { return new (t || FilteringWrapper)(); };
/** @nocollapse */ FilteringWrapper.ɵcmp = ɵɵdefineComponent({ type: FilteringWrapper, selectors: [["ng-component"]], inputs: { showGridByFilterValue: ["filterValue", "showGridByFilterValue"] }, decls: 0, vars: 0, template: function FilteringWrapper_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FilteringWrapper, [{
        type: Component,
        args: [{
                template: ''
            }]
    }], null, { showGridByFilterValue: [{
            type: Input,
            args: ['filterValue']
        }] }); })();

const CUSTOM_SMART_TABLE_CONFIG = new InjectionToken('SmartTableBackendWrapperConfig');

/*
 * Public API Surface of smart-table-backend-wrapper
 */
//SCSS

/**
 * Generated bundle index. Do not edit.
 */

export { BackendFilteringObject, CUSTOM_SMART_TABLE_CONFIG, CustomGridActiveStatusColumnComponent, CustomGridAvatarColumnComponent, CustomGridClickActionColumnComponent, CustomGridDateEditorComponent, CustomGridDateRangeFilterComponent, CustomGridNumberRangeFilterComponent, FilteringWrapper, GridConfigHolderComponent, PAGINATOR_EVENT, PaginatorComponent, SmartTableBackendWrapperComponent, SmartTableBackendWrapperConfigServiceAbstract, SmartTableBackendWrapperModule };
//# sourceMappingURL=smart-table-backend-wrapper.js.map
